
import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslation } from '@common/utils';

import { useSettings } from '@common/hooks';

import moment from 'moment';

import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
} from '@material-ui/core';

const monthsOptions = [
	{ value: 1, label: '1' },
	{ value: 2, label: '2' },
	{ value: 3, label: '3' },
	{ value: 4, label: '4' },
	{ value: 5, label: '5' },
	{ value: 6, label: '6' },
	{ value: 7, label: '7' },
	{ value: 8, label: '8' },
	{ value: 9, label: '9' },
	{ value: 10, label: '10' },
	{ value: 11, label: '11' },
	{ value: 12, label: '12' },
	{ value: 13, label: '13' },
	{ value: 14, label: '14' },
	{ value: 15, label: '15' },
	{ value: 16, label: '16' },
	{ value: 17, label: '17' },
	{ value: 18, label: '18' },
	{ value: 19, label: '19' },
	{ value: 20, label: '20' },
	{ value: 21, label: '21' },
	{ value: 22, label: '22' },
	{ value: 23, label: '23' },
	{ value: 24, label: '24' },
	{ value: 25, label: '25' },
	{ value: 26, label: '26' },
	{ value: 27, label: '27' },
	{ value: 28, label: '28' },
	{ value: 29, label: '29' },
	{ value: 30, label: '30' },
	{ value: 31, label: '31' },
	{ value: 32, label: '32' },
	{ value: 33, label: '33' },
	{ value: 34, label: '34' },
	{ value: 35, label: '35' },
	{ value: 36, label: '36' },
];

function MonthsPicker({ dates, setDates, boxes }) {
	const classes = useStyles();
	const tr = useTranslation();

	const { minimumDurationInMonths, maximumDurationInMonths } = useSettings();

	const months = dates.months || minimumDurationInMonths || 1;

	return (
		<FormControl variant="outlined" fullWidth={boxes} style={boxes ? {} : { minWidth: '100px' }} className={classes.container}>
			<InputLabel className={classes.label} >{tr('Months')}</InputLabel>
			<Select
				label={tr('Months')}
				value={months}
				MenuProps={{
					style: {
						maxHeight: 430,
					},
				}}
				onChange={(e) => setDates({
					...dates,
					months: e.target.value,
					to: moment(dates.from).add(e.target.value, 'months').toISOString(),
				})}
				SelectDisplayProps={{ style: { padding: '15.5px 14px' } }}
			>
				{monthsOptions.filter(m => m.value >= minimumDurationInMonths && m.value <= maximumDurationInMonths).map((option, i) => {
					return (
						<MenuItem key={i} value={option.value}>
							{tr(option.label)}
						</MenuItem>
					);
				})}
			</Select>
		</FormControl>
	);
}

MonthsPicker.propTypes = {
	dates: PropTypes.object.isRequired,
	setDates: PropTypes.func.isRequired,
	boxes: PropTypes.bool,
};

export default MonthsPicker;

const useStyles = makeStyles(theme => ({
	container: {
		marginLeft: '16px',
	},
	label: {
		background: theme.palette.common.white,
	},
}));
